// extracted by mini-css-extract-plugin
export var cardImage = "cta-image-card-module--card-image--7657f";
export var cardTitle = "cta-image-card-module--card-title--61712";
export var cardWrapper = "cta-image-card-module--card-wrapper--9befb";